const steps = [
  {
    num: "01",
    icon: "ri-message-3-line",
    title: "私訊或填表單",
    desc: "透過 Instagram 私訊 @rappy.meme，或填寫下方合作洽談表單，簡單說明你的需求與預算範圍。",
    tag: "最快 24 小時回覆",
    tagColor: "bg-red-50 text-red-600",
  },
  {
    num: "02",
    icon: "ri-phone-line",
    title: "需求溝通",
    desc: "我們會安排線上或電話會議，深入了解你的品牌目標、活動規模、時間安排與預期效果。",
    tag: "免費諮詢",
    tagColor: "bg-orange-50 text-orange-600",
  },
  {
    num: "03",
    icon: "ri-file-list-3-line",
    title: "提案與報價",
    desc: "根據需求量身打造專屬提案，提供詳細執行方案與透明報價，確認細節後簽訂合作合約。",
    tag: "客製化方案",
    tagColor: "bg-amber-50 text-amber-600",
  },
  {
    num: "04",
    icon: "ri-tools-line",
    title: "籌備執行",
    desc: "紅歡密專業團隊全程負責籌備，定期回報進度，確保每個環節都符合你的期待與品牌調性。",
    tag: "全程追蹤",
    tagColor: "bg-green-50 text-green-600",
  },
  {
    num: "05",
    icon: "ri-star-line",
    title: "活動落地",
    desc: "現場執行、攝影紀錄、即時應變，讓活動完美落地。結束後提供完整成果報告與素材交付。",
    tag: "成果交付",
    tagColor: "bg-teal-50 text-teal-600",
  },
];

export default function BusinessProcess() {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 rounded-full bg-red-50 text-red-600 text-xs font-semibold tracking-widest uppercase mb-4">
            How It Works
          </span>
          <h2
            className="text-3xl md:text-4xl font-black text-gray-900 mb-4"
            style={{ fontFamily: "'Noto Serif TC', serif" }}
          >
            合作流程
          </h2>
          <p className="text-gray-500 text-base max-w-lg mx-auto">
            從第一次聯繫到活動完美落地，我們陪你走完每一步
          </p>
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connector line (desktop) */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-gray-200 mx-20" />

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
            {steps.map((step, idx) => (
              <div key={step.num} className="relative flex flex-col items-center text-center group">
                {/* Step circle */}
                <div className="relative z-10 w-20 h-20 flex items-center justify-center rounded-full bg-white border-2 border-gray-100 group-hover:border-red-400 transition-all duration-300 mb-5">
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-50 group-hover:bg-red-600 transition-all duration-300">
                    <i className={`${step.icon} text-xl text-red-600 group-hover:text-white transition-colors duration-300`} />
                  </div>
                  {/* Step number badge */}
                  <span className="absolute -top-1 -right-1 w-6 h-6 flex items-center justify-center rounded-full bg-red-600 text-white text-xs font-black">
                    {idx + 1}
                  </span>
                </div>

                {/* Tag */}
                <span className={`inline-block px-3 py-0.5 rounded-full text-xs font-semibold mb-2 ${step.tagColor}`}>
                  {step.tag}
                </span>

                {/* Title */}
                <h3
                  className="font-black text-gray-900 text-base mb-2"
                  style={{ fontFamily: "'Noto Serif TC', serif" }}
                >
                  {step.title}
                </h3>

                {/* Desc */}
                <p className="text-gray-500 text-sm leading-relaxed">
                  {step.desc}
                </p>

                {/* Arrow (mobile) */}
                {idx < steps.length - 1 && (
                  <div className="lg:hidden mt-6 mb-2 w-6 h-6 flex items-center justify-center text-gray-300">
                    <i className="ri-arrow-down-line text-xl" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* Bottom CTA banner */}
        <div className="mt-16 rounded-2xl bg-white border border-gray-100 px-8 py-7 flex flex-col md:flex-row items-center justify-between gap-5">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-red-100 text-red-600 shrink-0">
              <i className="ri-time-line text-xl" />
            </div>
            <div>
              <p className="font-bold text-gray-900 text-base">最快 24 小時內回覆</p>
              <p className="text-gray-400 text-sm">私訊 IG 是最快速的聯繫方式，填表單也可以！</p>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href="https://www.instagram.com/rappy.meme/"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-full bg-red-600 text-white text-sm font-semibold hover:bg-red-700 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-instagram-line" />
              私訊 Instagram
            </a>
            <a
              href="#biz-form"
              className="inline-flex items-center justify-center gap-2 px-6 py-2.5 rounded-full border-2 border-gray-200 text-gray-700 text-sm font-semibold hover:border-red-400 hover:text-red-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-list-3-line" />
              填寫合作表單
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
